export default import.meta.ROLLUP_FILE_URL_DAeamOqTz1c7$1GY3q6aQw